// extracted by css-extract-rspack-plugin
export default {"root":"root-MpvtNh","text":"text-ba2MTH text-headline-lg"};